import { FC, useRef } from 'react';
import { cn } from '@/lib/utils';
import Word from '@/components/ui/icons/new/Word';
import Pdf from '@/components/ui/icons/new/Pdf';
import { useAppDispatch } from '@/lib/hooks/hooks';
import { startManualExport } from '@/redux/slices/manualSolicitationSlice';
import { DocumentType } from '@/lib/types/apiTypes';

interface ManualSolicitationHeaderProps {}

const ManualSolicitationHeader: FC<ManualSolicitationHeaderProps> = () => {
	const headerRef = useRef<HTMLDivElement>(null);
	const dispatch = useAppDispatch();

	const handleExport = (type: DocumentType) => {
		dispatch(startManualExport(type));
	};

	return (
		<div
			ref={headerRef}
			className={cn(
				'flex items-center z-10 rounded-3xl shadow-main bg-white px-6 py-4 relative'
			)}
		>
			<ul className="flex items-center justify-start gap-4">
				<li
					onClick={() => handleExport('docx')}
					className="cursor-pointer animated-hover-effect"
				>
					<Word />
				</li>
				<li
					onClick={() => handleExport('pdf')}
					className="cursor-pointer animated-hover-effect "
				>
					<Pdf />
				</li>
			</ul>
		</div>
	);
};

export default ManualSolicitationHeader;
